// src/components/lessons/renderers/TipRenderer.jsx
import React, { useState } from 'react';
import { Lightbulb } from 'lucide-react';

const TipRenderer = ({ block, isMobile }) => {
  const [isHovered, setIsHovered] = useState(false);
    const processText = (text) => {
    if (typeof text !== 'string') return text;
    const parts = text.split(/\*\*(.*?)\*\*/g);
    return parts.map((part, index) => {
      return index % 2 === 1 ? (
        <strong key={index} style={{
          fontWeight: '700',
          color: '#000000',
          background: '#FFFFFF',
          padding: '0.125rem 0.375rem',
          borderRadius: '0.25rem',
          border: '1px solid #E5E7EB'
        }}>
          {part}
        </strong>
      ) : part;
    });
  };
  return (
    <div
      style={{
        background: '#FFFFFF',
        borderRadius: isMobile ? '0.5rem' : '0.75rem',
        padding: isMobile ? '1rem' : '1.5rem',
        border: '2px solid #000000',
        marginBottom: isMobile ? '1rem' : '1.5rem',
        boxShadow: isHovered ? '0 8px 24px rgba(0, 0, 0, 0.12)' : '0 2px 8px rgba(0, 0, 0, 0.08)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        transform: isHovered ? 'translateY(-2px)' : 'translateY(0)',
        position: 'relative',
        overflow: 'hidden'
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Blue accent bar at top */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        height: '4px',
        background: '#3A86FF'
      }} />

      <h4 style={{
        fontWeight: '700',
        color: '#000000',
        marginBottom: isMobile ? '0.75rem' : '1rem',
        marginTop: isMobile ? '0.25rem' : '0.5rem',
        display: 'flex',
        alignItems: 'center',
        gap: isMobile ? '0.5rem' : '0.75rem',
        fontSize: isMobile ? '0.9375rem' : '1.1rem'
      }}>
        <div style={{
          width: isMobile ? '28px' : '32px',
          height: isMobile ? '28px' : '32px',
          borderRadius: '50%',
          background: '#000000',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#3A86FF',
          transition: 'transform 0.3s ease',
          transform: isHovered ? 'rotate(12deg) scale(1.1)' : 'rotate(0deg) scale(1)'
        }}>
          <Lightbulb size={16} />
        </div>
        {block.title}
      </h4>
      <p style={{
        color: '#000000',
        lineHeight: isMobile ? '1.65' : '1.7',
        fontSize: isMobile ? '0.9375rem' : '1rem',
        margin: 0,
        opacity: 0.85
      }}>
      {processText(block.content)}
      </p>

      {/* Decorative corner dot */}
      {isHovered && (
        <div style={{
          position: 'absolute',
          bottom: '12px',
          right: '12px',
          width: '6px',
          height: '6px',
          borderRadius: '50%',
          background: '#3A86FF',
          animation: 'pulse 1.5s ease-in-out infinite'
        }} />
      )}
    </div>
  );
};

export default TipRenderer;